export default "__VITE_ASSET__199b30d8__"